(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/swish-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/swish-service.js');

'use strict';

const jupiter = svs.core.jupiter;
const analytics = svs.components.analytics;
const logger = svs.accountservicesReact.deposit.swish.logger;
const swishstatus = svs.accountservicesReact.deposit.constants.swishstatus;
const swishPollInterval = svs.accountservicesReact.deposit.data.swishPollInterval || 4000;

const executeSwishDepositAsync = async data => {
  try {
    const swishData = {
      cellphone: data.cellPhone,
      amount: svs.utils.format.CurrencyAsJupiterString(data.amount)
    };
    const _await$jupiter$callAs = await jupiter.callAsync({
        method: 'POST',
        path: svs.core.detect.formfactor.mobile() ? '/player/1/swishmcomtransfer' : '/player/1/swishecomtransfer',
        data: swishData
      }),
      response = _await$jupiter$callAs.response;
    analytics.trackEvent({
      category: 'Deposits',
      action: 'Deposit init Success',
      opt_label: 'Swish',
      opt_value: parseInt(data.transAmount, 10)
    });
    return response;
  } catch (err) {
    const errorCode = (err === null || err === void 0 ? void 0 : err.code) || 0;
    svs.components.analytics.trackEvent({
      category: 'Deposits',
      action: 'Deposit init Failure',
      opt_label: 'Swish',
      opt_value: errorCode
    });
    throw err;
  }
};

const swishHandleCommunicationSettingsAsync = async hasCellPhoneBeforeSwishDeposit => {
  if (!hasCellPhoneBeforeSwishDeposit) {
    try {
      await jupiter.callAsync({
        method: 'PUT',
        path: '/player/1/settings',
        data: {
          settings: [{
            key: 'advertisingSms',
            value: true
          }]
        }
      });
      logger.debug('Saved communication setting for cellphone after Swish deposit with new cellphone number');
    } catch (err) {
      const errorCode = (err === null || err === void 0 ? void 0 : err.code) || 0;
      if (errorCode === 12000) {
        logger.debug('Error setting communications setting for cellphone after Swish deposit with new cellphone number, probably already set to true before', err);
      } else {
        logger.warn('Error setting communications setting for cellphone after Swish deposit with new cellphone number', err);
      }
    }
  }
};

const getPollSwishDepositAsync = async data => {
  try {
    const options = {
      method: 'GET',
      path: "/player/1/transfer/status/".concat(data.transactionId)
    };
    const _await$jupiter$callAs2 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs2.response;
    return {
      transferStatus: response.transferStatus,
      accountBalance: response.accountBalance,
      error: response
    };
  } catch (err) {
    return {
      transferStatus: 'failed',
      error: err
    };
  }
};

const pollSwishDepositAsync = async transactionId => new Promise(resolve => {
  logger.debug("transactionId: ".concat(transactionId));

  const pollStatus = async () => {
    try {
      logger.debug('**** swish poll...');
      if (document.visibilityState === 'visible') {
        const _await$getPollSwishDe = await getPollSwishDepositAsync({
            transactionId
          }),
          transferStatus = _await$getPollSwishDe.transferStatus,
          accountBalance = _await$getPollSwishDe.accountBalance,
          error = _await$getPollSwishDe.error;
        logger.debug({
          transferStatus
        });
        if ((transferStatus === null || transferStatus === void 0 ? void 0 : transferStatus.toLowerCase()) === 'success') {
          logger.debug('Swish deposit ok!');
          clearInterval(window.globalIntervalId); 
          resolve({
            status: swishstatus.OK,
            accountBalance
          });
        } else if ((transferStatus === null || transferStatus === void 0 ? void 0 : transferStatus.toLowerCase()) === 'failed' || (transferStatus === null || transferStatus === void 0 ? void 0 : transferStatus.toLowerCase()) === 'cancelled') {
          const errCode = (error === null || error === void 0 ? void 0 : error.code) || (error === null || error === void 0 ? void 0 : error.errorCode) || 101; 
          const errMessage = (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.errorMessage) || '%20The%20internal%20error%20was:%Error%20polling%20swish%20status';
          const err = {
            responseJSON: {
              error: {
                code: errCode,
                message: errMessage
              }
            }
          };
          svs.components.analytics.trackEvent({
            category: 'Deposits',
            action: 'Deposit Failure',
            opt_label: 'Swish',
            opt_value: isNaN(errCode) ? 0 : errCode
          });
          clearInterval(window.globalIntervalId);
          resolve({
            status: swishstatus.ERROR_SWISH,
            error: err
          });
        } else {
          logger.debug('Poll for Swish deposit status again');
          window.globalIntervalId = setTimeout(pollStatus, swishPollInterval);
        }
      } else {
        logger.debug('Page is hidden. Do not check for Swish status');
        window.globalIntervalId = setTimeout(pollStatus, swishPollInterval);
      }
    } catch (err) {
      clearInterval(window.globalIntervalId);
      resolve({
        status: swishstatus.ERROR_INTERNAL,
        error: err
      });
    }
  };
  window.globalIntervalId = setTimeout(pollStatus, swishPollInterval);
});
svs.accountservicesReact.deposit.services.SwishService = {
  executeSwishDepositAsync,
  pollSwishDepositAsync,
  swishHandleCommunicationSettingsAsync
};

 })(window);